// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-tile {
  width: 20rem;
  margin: 0 1rem -0.75rem 0;
  padding-left: 1rem;
}
.settings-tile .setting.label-text {
  margin: 0 0 0 0.5rem;
  width: unset;
}
.settings-tile .settings-backdrop {
  background-color: rgba(0, 0, 0, 0.1);
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 13rem;
  animation-name: blur-in;
  animation-duration: 0.1s;
  animation-fill-mode: forwards;
  z-index: 999;
}
.settings-tile .settings-container {
  border: var(--border-width) solid var(--color-base-border);
  float: right;
  text-align: right;
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
  position: absolute;
  top: 0.25rem;
  right: 0.5rem;
  z-index: 1000;
}
.settings-tile .settings-container .settings-popover {
  border: var(--border-width) solid var(--color-base-border);
  position: relative;
  z-index: 1000;
}
.settings-tile .settings-container .settings-button {
  background-color: var(--color-elevated-canvas);
  border-color: var(--color-elevated-canvas);
  fill: var(--color-elevated-draw);
  position: relative;
  top: 0.1rem;
  right: -0.8em;
  z-index: 1000;
}
.settings-tile .settings-container .settings-title {
  cursor: default;
  position: relative;
  top: -2.8rem;
  right: 1.7rem;
  margin-bottom: -2.2rem;
  z-index: 1000;
}
.settings-tile .settings-container .setting.label {
  display: block;
}
.settings-tile .settings-container .setting.label:first-of-type {
  border-top: var(--border-width) solid var(--color-elevated-border);
  padding-top: 0.5rem;
}
.settings-tile .settings-container .setting.checkbox {
  margin-left: 0.7rem;
  z-index: 1000;
}

.settings-tile.open .settings-backdrop {
  display: unset;
}
.settings-tile.open .settings-container {
  background-color: var(--color-elevated-canvas);
  border-color: var(--color-elevated-border);
  position: absolute;
}

.settings-tile.closed .settings-popover {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/style/settings_tile.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;AACF;AACE;EACE,oBAAA;EACA,YAAA;AACJ;AAEE;EACE,oCAAA;EACA,aAAA;EACA,eAAA;EAAiB,MAAA;EAAQ,QAAA;EAAU,SAAA;EAAW,WAAA;EAC9C,uBAAA;EACA,wBAAA;EACA,6BAAA;EACA,YAAA;AAIJ;AADE;EACE,0DAAA;EACA,YAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;EAAoB,YAAA;EAAc,aAAA;EAClC,aAAA;AAKJ;AAHI;EACE,0DAAA;EACA,kBAAA;EACA,aAAA;AAKN;AAFI;EACE,8CAAA;EACA,0CAAA;EACA,gCAAA;EACA,kBAAA;EAAoB,WAAA;EAAa,aAAA;EACjC,aAAA;AAMN;AAFI;EACE,eAAA;EACA,kBAAA;EAAoB,YAAA;EAAc,aAAA;EAClC,sBAAA;EACA,aAAA;AAMN;AAHI;EACE,cAAA;AAKN;AAHI;EACE,kEAAA;EACA,mBAAA;AAKN;AAHI;EACE,mBAAA;EAEA,aAAA;AAIN;;AAEE;EACE,cAAA;AACJ;AAEE;EACI,8CAAA;EACA,0CAAA;EACA,kBAAA;AAAN;;AAIA;EACE,aAAA;AADF","sourcesContent":[".settings-tile {\n  width: 20rem;\n  margin: 0 1rem -0.75rem 0;\n  padding-left: 1rem;\n\n  .setting.label-text {\n    margin: 0 0 0 0.5rem;\n    width: unset;\n  }\n\n  .settings-backdrop {\n    background-color: rgba(0, 0, 0, 0.1);\n    display: none;\n    position: fixed; top: 0; right: 0; bottom: 0; left: 13rem;\n    animation-name: blur-in;\n    animation-duration: 0.1s;\n    animation-fill-mode: forwards;\n    z-index: 999;\n  }\n\n  .settings-container {\n    border: var(--border-width) solid var(--color-base-border);\n    float: right;\n    text-align: right;\n    padding: 0.5rem 0.5rem 0.5rem 1.5rem;\n    position: absolute; top: 0.25rem; right: 0.5rem;\n    z-index: 1000;\n\n    .settings-popover {\n      border: var(--border-width) solid var(--color-base-border);\n      position: relative;\n      z-index: 1000;\n    }\n\n    .settings-button {\n      background-color: var(--color-elevated-canvas);\n      border-color: var(--color-elevated-canvas);\n      fill: var(--color-elevated-draw);\n      position: relative; top: 0.1rem; right: -0.8em;\n      z-index: 1000;\n      // position: absolute; top: 0.7rem;\n    }\n\n    .settings-title {\n      cursor: default;\n      position: relative; top: -2.8rem; right: 1.7rem;\n      margin-bottom: -2.2rem;\n      z-index: 1000;\n    }\n\n    .setting.label {\n      display: block;\n    }\n    .setting.label:first-of-type {\n      border-top: var(--border-width) solid var(--color-elevated-border);\n      padding-top: 0.5rem;\n    }\n    .setting.checkbox {\n      margin-left: 0.7rem;\n      // position: relative;\n      z-index: 1000;\n    }\n  }\n}\n\n.settings-tile.open {\n  .settings-backdrop {\n    display: unset;\n  }\n\n  .settings-container {\n      background-color: var(--color-elevated-canvas);\n      border-color: var(--color-elevated-border);\n      position: absolute;\n  }\n}\n\n.settings-tile.closed .settings-popover {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
